import {useContext} from "react";
import AppContext from "../AppContext";
import {Alert, Button} from "react-bootstrap";
import {PiLightningBold} from "react-icons/pi";
import {Trans} from "react-i18next/icu.macro";
import {useTranslation} from "react-i18next";

export default function PendingOrderNotice() {
    const app = useContext(AppContext)
    const {t, i18n} = useTranslation()
    const subs = app.user.subscriptions;

    const isOnPage = window.location.hash.indexOf('orders') !== -1;

    let sub = false;
    switch (app.user.current_course) {
        case 1:
            sub = subs?.bth;
            break;
        case 2:
            sub = subs?.ath;
            break;
        case 3:
            sub = subs?.amth;
            break;
    }

    if (sub && sub.pending > 0 && !sub?.promo_active && !isOnPage)
        return <Alert variant="info" style={{fontSize: 14}}>
            <div>
                <PiLightningBold />
                <Trans i18nKey="orderNoticeOrders" count={sub.pending_orders} />
                &nbsp;
                <Trans i18nKey="orderNoticeDays" count={sub.pending} />
            </div>
            <div className="alert-buttons">
                <Button href="/account#orders" variant="link" color="info" size="sm">
                    {t('button.activateNow')}
                </Button>
            </div>
        </Alert>

    return <></>
}